import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import GlobalState from "./context/state";
import { ThemeProvider, createTheme } from '@mui/material';

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";

const theme = createTheme({
  palette: {
    primary: {
      main: '#ea0089',
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <GlobalState>
          <App />
        </GlobalState>
      </BrowserRouter>
    </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
